import { nanoid } from "nanoid";
import { FilterItem, GroupFilter, RowFilter } from "./types";

// Node fatory functions
// - create row and group with default values and unique ids
// - used for initialization and adding new nodes in the form

export const createRow = (): FilterItem => {
	const row: RowFilter = {
		id: nanoid(),
		filter: undefined,
		operator: undefined,
		value: undefined,
	};

	return {
		type: "row",
		value: row,
	};
};

export const createGroup = (): FilterItem => {
	const group: GroupFilter = {
		id: nanoid(),
		rowOperator: "and",
		rows: [createRow()],
	};

	return {
		type: "group",
		value: group,
	};
};
